import * as React from 'react';
import { WebDate } from '../../../../../WebDate';

import * as main from '../../../styles/main.module.scss';
import * as screen1 from './screen1a.module.scss';

export const Screen1a = () => {
  return (
    <section id={"screen1"}>
      <div className={"container"}>
        <div className={screen1.screen1__innerContainer}>
          <div className={screen1.screen1__info}>
            <p className={screen1.screen1__subtitle}>Бесплатный онлайн-мастер-класс</p>
            <p className={screen1.screen1__date}><WebDate id={'br2025'}/></p>
          </div>
          <div className={screen1.screen1__mainInfo}>
            <h1 className={screen1.screen1__title}>Как омолодить мозг на 20 лет и начать вторую молодость</h1>
            <ul className={screen1.screen1__doList}>
              <li className={screen1.screen1__doItem}>Наполните мозг силой без таблеток</li>
              <li className={screen1.screen1__doItem}>Наполните жизнь энергией</li>
              <li className={screen1.screen1__doItem}>Перестаньте уставать</li>
            </ul>
            <a href={"#widget"} data-target={"#widget"} className={main.mainBtn}>Зарегистрироваться</a>
          </div>
        </div>
      </div>
    </section>
  );
};
